// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"63a72efc","239":"8595b08a","272":"7d3e7770","285":"596b3bae","318":"2fd596de","322":"96d9e3ed","341":"b8e92e47","354":"83515c75","424":"cbc89b87","453":"db036399","549":"334e8618","589":"7b1d947a","752":"08d31266","759":"687e5fc6","849":"fc303e46"}[chunkId] + ".chunk.js";
};